import { Badge, Card, CardBody, Col, ListGroup, Row, Table } from 'reactstrap';
import { ApplicableTransaction } from '../models/subscriptionsModel';

interface Props {
  applicableTransactions: ApplicableTransaction[];
}

const TransactionSubscriptionList = ({ applicableTransactions }: Props) => {
  return (
    <Row>
      <Col lg="12">
        <Card>
          <CardBody>
            <ListGroup className="list my--3" flush>
              <h6 className="heading-small text-muted mt-4 mb-4">
                Visualización de transacciones aplicables a rental managment
              </h6>
            </ListGroup>
            {applicableTransactions.length > 0 && (
              <div
                style={{
                  height: '200px',
                  overflow: 'scroll',
                }}
              >
                <Table
                  className="align-items-center table-flush hei"
                  responsive
                >
                  <thead className="thead-light">
                    <tr>
                      <th scope="col">Fecha de pago</th>
                      <th scope="col">Correlativo Fecha pago</th>
                      <th scope="col">Precio</th>
                      <th scope="col">Precio de subscripción</th>
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {applicableTransactions.map((transaction) => (
                      <tr key={transaction.id}>
                        <td>{transaction.due_date}</td>
                        <td>{transaction.due}</td>
                        <td>{transaction.price_formatted}</td>
                        <td>{transaction.price_subscription_formatted}</td>
                        <td>
                          {transaction.apply_subscription_price ? (
                            <Badge color="success">Requiere pago</Badge>
                          ) : (
                            <Badge color="warning">No Requiere pago</Badge>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            )}
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default TransactionSubscriptionList;
